import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { PessoaFisica } from 'src/app/core/pessoa-fisica';
import { DataUtilService } from 'src/app/services/commons/data-util.service';
import { EnderecoService } from 'src/app/services/endereco/endereco.service';

@Component({
  selector: 'documentos-aluno',
  templateUrl: './documentos-aluno.component.html',
  styleUrls: ['./documentos-aluno.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DocumentosAlunoComponent implements OnInit {

  @Input() pessoaFisica: PessoaFisica;
  @Input() validaCPF: boolean = true;
  @Input() apresentaCPF: boolean = true;

  public mascaraCpf = [];
  public mascaraNIS = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, /\d/, '.', /\d/, /\d/, '-', /\d/];


  constructor(
    private enderecoService:EnderecoService,
    private dataUtilService: DataUtilService
  ) {
   }

  ngOnInit() {
    this.adicionarMascara();
  }


  adicionarMascara() {
    this.mascaraCpf = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,];
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onUfCiChange(uf: any) {
    this.pessoaFisica.ufCi = uf?.nome;
  }

}
